import React from 'react';

import SectionContainer from '../layout/SectionContainer.jsx';
import ContentContainer from '../layout/ContentContainer.jsx';
import SectionNav from '../layout/SectionNav.jsx';
import Field from '../layout/Field.jsx';

const TaskApprovalSection = ({
	Registry,
	onChange,
	name = 'taskApprovalSection',
	values,
	disabled = false,
	navigationProps,
}) => {
	const canContinue = values['approval'] !== undefined;

	const handleNext = async (event) => {
		return navigationProps.next(event);
	};


	return (
		<SectionContainer
			Navigation={
				<SectionNav
					{...navigationProps}
					hasPrevious={false}
					canContinue={canContinue}
					next={handleNext}
				/>
			}
		><ContentContainer>
				<Field
					Registry={Registry}
					type={'TextArea'}
					label={'Provide a reason for the approval or declination'}
					key={'reason'}
					name={'reason'}
					value={values['reason']}
					disabled={disabled}
					onChange={onChange}
				/>
				<Field
					Registry={Registry}
					type={'TaskApproval'}
					key={'approval'}
					name={'approval'}
					value={values['approval']}
					disabled={disabled}
					onChange={onChange}
				/>
			</ContentContainer>
		</SectionContainer>
 	);
};


TaskApprovalSection.type = 'TaskApprovalSection';
TaskApprovalSection.hasNavigation = true;

export default TaskApprovalSection;
